'use client'

import type { ProfileResponseSchema } from '@cocoonspace/sdk-js/v2/types/profileResponseSchema'

import { AppWrapper } from '~/components/app-wrapper'
import { UserPublicPage } from '~/domains/public-page/user-public-page'

export const Page = ({
	userProfile,
}: {
	userProfile: ProfileResponseSchema
}) => {
	if (!userProfile) return null

	return (
		<AppWrapper>
			<UserPublicPage
				userProfile={userProfile}
				profileSlugHref={userProfile.slug ?? undefined}
			/>
		</AppWrapper>
	)
}
